import axios from '~/common/plugins/axios.js'
export const state = () => ({
  tableDataForDemo: [],
})

export const mutations = {
  set_tableDataForDemo(state,v) {
    state.tableDataForDemo = v
  }
}

export const actions = {
  async get_tableDataForDemo ({ commit }) {
    const _tableDataForDemo = await axios.$get('back/v1/tabledatafordemo')
    console.log(_tableDataForDemo)
    commit('set_tableDataForDemo',_tableDataForDemo)
  }
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
}
